/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';

export const profileThemeConfig = () => (makeStyles((theme) => ({
  paper: {
    // background: 'linear-gradient(137.62deg, #04043B 0%, #280548 30%);',
    background: '#000000e0',
    boxShadow: theme.shadows[5],
    color: '#fff',
    borderRadius: '10px',
    [theme.breakpoints.up('lg')]: {
      width: '23.5%',
    },
    [theme.breakpoints.down('md')]: {
      width: '95.4%',
    },
    height: '400px',
    padding: '17px',
    paddingBottom: '20px',
    margin: '100px 10px 0px 10px',
    textAlign: 'center',
    boxSizing: 'border-box',
    position: 'absolute',
    zIndex: '5',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    bottom: '15vh',
  },
  mobileView: {
    // background: 'linear-gradient(137.62deg, #04043B 0%, #280548 30%);',
    background: '#000000e0',
    boxShadow: theme.shadows[5],
    color: '#fff',
    borderRadius: '10px',
    width: '95%',
    height: '400px',
    padding: '17px',
    paddingBottom: '20px',
    margin: '100px 10px 0px 10px',
    textAlign: 'center',
    boxSizing: 'border-box',
    position: 'absolute',
    zIndex: '5',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    bottom: '15vh',
  },
}))
);
